<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="会员名称" prop="name" :label-width="labelWidth">
					<el-input :disabled='JSON.parse(viewFlag)' style="width: 400px;" v-model="ruleForm.name"
						placeholder="请输入1-10位会员名称，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="下级会员" :label-width="labelWidth"
					v-if="ruleForm.level==1 && !JSON.parse(viewFlag) && JSON.parse(editFlag)">
					<el-input style="width: 400px;"
						v-if="ruleForm.level==1 && !JSON.parse(viewFlag) && JSON.parse(editFlag)" placeholder="末级会员"
						disabled />
				</el-form-item>
				<el-form-item label="下级会员" prop="pid" :label-width="labelWidth" v-else>
					<el-select v-if="ruleForm.level!=1"
						:disabled='JSON.parse(viewFlag) || ruleForm.level==1 || ruleForm.uuid!=""' style="width: 400px;"
						v-model="ruleForm.pid" placeholder="请选择下级会员">
						<el-option v-for="item in pids" :label="item.name" :value="item.uuid"></el-option>
					</el-select>
					<el-input style="width: 400px;"
						v-if="ruleForm.level==1 && JSON.parse(viewFlag) && !JSON.parse(editFlag)" placeholder="末级会员"
						disabled />
				</el-form-item>
				<el-form-item label="会员售价选择" prop="resource" :label-width="labelWidth">
					<!-- <el-radio label="微信" v-model="wxradio"></el-radio>
					<el-radio label="积分" v-model="jfradio"></el-radio> -->

					<el-checkbox-group v-model="checkList" @change="checkListChange">
						<el-checkbox label="微信"></el-checkbox>
						<el-checkbox label="积分"></el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="会员微信售价" v-if="checkList.indexOf('微信') !=-1" prop="price" :label-width="labelWidth">
					<el-input :disabled='JSON.parse(viewFlag) || ruleForm.level==1' style="width: 400px;" type="number"
						placeholder="请输入大于0的数字" v-model="ruleForm.price"></el-input>
				</el-form-item>
				<el-form-item label="会员积分售价" v-if="checkList.indexOf('积分') !=-1" prop="score" :label-width="labelWidth">
					<el-input :disabled='JSON.parse(viewFlag) || ruleForm.level==1' style="width: 400px;" type="number"
						placeholder="请输入大于0的数字" v-model="ruleForm.score"></el-input>
				</el-form-item>
				<el-form-item label="会员图标" prop="img" :label-width="labelWidth">
					<ImageUpload v-if="!JSON.parse(viewFlag)" :limit='1' @input='imageUpload'
						:onloadImageList='onloadImageList'>
					</ImageUpload>
					<div v-if="!JSON.parse(viewFlag)" style="color: #999;">支持扩展名：.png .jpg .jpeg
						请上传小于20M图片，请上传比例为1:1的图片比例</div>
					<img @click="viewImage(ruleForm.img.indexOf('http')!=-1? ruleForm.img:imgDomain+ruleForm.img)"
						:src="ruleForm.img.indexOf('http')!=-1? ruleForm.img:imgDomain+ruleForm.img"
						style="width: 150px;height: 150px;" v-if="JSON.parse(viewFlag)" class="pointer" />
				</el-form-item>
				<el-form-item label="背景图片" prop="bg_img" :label-width="labelWidth">
					<ImageUpload style="width: auto;" v-if="!JSON.parse(viewFlag)" :limit='1' @input='imageBgUpload'
						:onloadImageList='onloadBgImageList'>
					</ImageUpload>
					<img @click="viewBgImage(ruleForm.bg_img.indexOf('http')!=-1? ruleForm.bg_img:imgDomain+ruleForm.bg_img)"
						:src="ruleForm.bg_img.indexOf('http')!=-1? ruleForm.bg_img:imgDomain+ruleForm.bg_img"
						style="width: auto;height: 150px;" v-if="JSON.parse(viewFlag)" class="pointer" />
				</el-form-item>
				<!-- <el-form-item label="会员卡片底色" prop="bg" :label-width="labelWidth">
					<el-input :disabled='JSON.parse(viewFlag)' style="width: 400px;" placeholder="请输入颜色HEX代码"
						v-model="ruleForm.bg"></el-input>
				</el-form-item> -->
				<el-form-item label="会员卡片文字颜色" prop="text_color" :label-width="labelWidth">
					<el-input :disabled='JSON.parse(viewFlag)' style="width: 400px;" placeholder="请输入颜色HEX代码"
						v-model="ruleForm.text_color"></el-input>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<h4>会员权益</h4>
			</div>
			<h4 style="margin-bottom: 20px;">请选择当前会员享有权益（支持多选）</h4>
			<el-checkbox :disabled='JSON.parse(viewFlag) || ruleForm.level==1' v-model="kczk" :true-label='1'
				:false-label='2'>课程折扣</el-checkbox>
			<div class="flex" style="margin: 20px 0;" v-if="kczk == 1">
				<div>单章节优惠积分</div>
				<el-input :disabled='JSON.parse(viewFlag) || ruleForm.level==1' style="margin: 0 10px;width: 150px;"
					v-model="ruleForm.discount" />
				<div style="margin-left: 20px;">整章购买优惠积分</div>
				<el-input :disabled='JSON.parse(viewFlag) || ruleForm.level==1' style="margin-left: 10px;width: 150px;"
					v-model="ruleForm.all_discount" />
			</div>
			<el-checkbox :disabled='JSON.parse(viewFlag) || ruleForm.level==1' v-model="jffb" :true-label='1'
				:false-label='2' @change="jffbChange">日常积分获取翻倍</el-checkbox>
			<div class="flex" style="margin: 20px 0;" v-if="jffb == 1">
				<div>翻倍倍数</div>
				<el-input :disabled='JSON.parse(viewFlag) || ruleForm.level==1' style="margin: 0 10px;width: 150px;"
					v-model="ruleForm.doubled" />
			</div>
			<!-- <el-radio v-model="ruleForm.is_fee" :label="1">全平台课程免费学习</el-radio> -->

			<el-checkbox :disabled='JSON.parse(viewFlag) || ruleForm.level==1' v-model="ruleForm.is_fee" :true-label='1'
				:false-label='2'>全平台课程免费学习</el-checkbox>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" plain @click="resetForm('ruleForm')">返回</el-button>
			<el-button type="primary" style="width: 150px;" v-if="!JSON.parse(viewFlag)"
				@click="submitForm('ruleForm')">保存</el-button>
		</el-card>

		<PriviewImgVue :previewImg="previewImg"></PriviewImgVue>
	</div>
</template>

<script>
	import PriviewImgVue from '@/components/PriviewImg.vue';
	import ImageUpload from "../../../components/ImageUpload.vue";
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		getMemberList,
		addMember,
		updateMember,
		getMemberDetail
	} from "@/api/user"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				checkList: ['微信', '积分'],
				labelWidth: '150px',
				radio: '2',
				imgDomain,
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				value: '500',
				ruleForm: {
					level: '',
					name: '',
					text_color: '',
					resource: '微信',
					pid: '',
					price: '',
					img: '',
					score: '',
					bg: '',
					uuid: '',
					is_fee: '2',
					doubled: '',
					all_discount: '',
					discount: '',
					bg_img: ''
				},
				rules: {
					name: [{
							required: true,
							message: '请输入会员名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 10,
							message: '长度在 1 到 10 个字符',
							trigger: 'blur'
						}
					],
					pid: [{
						required: true,
						message: '请选择下级会员',
						trigger: 'change'
					}],
					price: [{
						required: true,
						message: '请输入会员微信售价',
						trigger: 'change'
					}],
					score: [{
						required: true,
						message: '请输入会员积分售价',
						trigger: 'change'
					}],
					bg: [{
						required: true,
						message: '请输入颜色HEX代码',
						trigger: 'blur'
					}],
					text_color: [{
						required: true,
						message: '请输入颜色HEX代码',
						trigger: 'blur'
					}],
					img: [{
						required: true,
						message: '请上传会员图标',
						trigger: 'blur'
					}],
					bg_img: [{
						required: true,
						message: '请上传背景图片',
						trigger: 'blur'
					}],
				},
				kczk: '',
				jffb: '',
				pids: [],
				onloadImageList: [],
				onloadBgImageList: [],
				wxradio: '微信',
				jfradio: '积分',
				viewFlag: false,
				editFlag: false,
				previewImg: {
					popup: false,
					index: 0,
					imgList: []
				}
			};
		},
		components: {
			CommonPagination,
			ImageUpload,
			PriviewImgVue
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.onloadImageList = []
			this.onloadBgImageList = []
			if (this.$route.query.viewFlag) {
				this.viewFlag = this.$route.query.viewFlag
			}
			if (this.$route.query.editFlag) {
				this.editFlag = this.$route.query.editFlag
			}
			this.getMemberList()
			if (uuid) {
				this.uuid = uuid
				this.ruleForm.uuid = uuid
				this.getMemberDetail(uuid);
			}
		},
		methods: {
			checkListChange(e){
				if(e.indexOf('微信')==-1){
					this.ruleForm.price = ''
				}
				if(e.indexOf('积分')==-1){
					this.ruleForm.score = ''
				}
			},
			jffbChange(e) {
				if (e == 2) {
					this.ruleForm.doubled = 0
				}
			},
			viewImage(url) {
				this.previewImg.imgList = []
				this.previewImg.imgList.push(url)
				this.previewImg.popup = true
			},
			imageUpload(e) {
				this.ruleForm.img = imgDomain + e[0]
			},
			imageBgUpload(e) {
				this.ruleForm.bg_img = imgDomain + e[0]
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.uuid) {
							this.addMember()
						} else {
							this.updateMember()
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				if(this.ruleForm.level!=1){
					this.$refs[formName].resetFields();
				}
				this.goBack()
			},
			handlePageChange(page) {
				this.page_index = page
				this.getMemberList()
			},
			handlePageChange1(page) {
				this.page_index1 = page
				this.getAiApplicationHistoryList()
			},
			handleClick(tab, event) {
				if (tab.name == 'second') {
					this.getAiApplicationHistoryList()
				}
				if (tab.name == 'first') {
					this.getMemberList()
				}
			},
			async getMemberList() {
				let postData = {
					page_size: 9999,
					page_index: 1,
				};
				const {
					status,
					data
				} = await getMemberList(postData);
				if (status !== 200) return;
				if (!this.uuid) {
					this.pids.push(data.result.data[data.result.data.length - 1]);
				} else {
					this.pids = data.result.data
				}
			},
			async getAiApplicationHistoryList() {
				let postData = {
					page_size: this.page_size1,
					page_index: this.page_index1,
					user_uuid: this.user_uuid
				};
				const {
					status,
					data
				} = await getAiApplicationHistoryList(postData);
				if (status !== 200) return;
				this.hisLists = data.result.data;
				this.total1 = data.result.total;
			},
			goBack() {
				this.$router.go(-1)
			},
			async getMemberDetail(uuid) {
				const {
					data,
					status
				} = await getMemberDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.ruleForm = data.result
					this.checkList = []
					if(this.ruleForm.price&&this.ruleForm.price>0){
						this.checkList.push('微信')
					}
					if(this.ruleForm.score&&this.ruleForm.score>0){
						this.checkList.push('积分')
					}
					if (this.ruleForm.discount) {
						this.kczk = 1
					}
					if (this.ruleForm.doubled) {
						this.jffb = 1
					}
					this.onloadImageList.push(this.ruleForm.img)
					this.onloadBgImageList.push(this.ruleForm.bg_img)
				}
			},
			async addMember(uuid) {
				const {
					data,
					status
				} = await addMember({
					...this.ruleForm
				});
				if (status === 200) {
					this.$message.success('新增成功')
					this.handleClickBack()
				}
			},
			async updateMember(uuid) {
				const {
					data,
					status
				} = await updateMember({
					...this.ruleForm
				});
				if (status === 200) {
					this.$message.success('修改成功')
					this.handleClickBack()
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}

	::v-deep .upload_img {
		width: auto !important;
	}
</style>